import { Col, Row, Spin } from "antd";
import React from 'react';
import ActionBar from "../../../../components/action-bar";
import ActionButton from "../../../../components/action-button";
import { useSelector } from "react-redux";
import { fetchResposta, hasPermissaoSelector, respostaSelector } from "../../../../store/consultivoConsulta";
import useLoading from "../../../../hooks/useLoading";
import { useHistory, useRouteMatch } from "react-router";
import TextItem from "../../../../components/text-item";
import { useTranslation } from "react-i18next";
import { Consulta } from "../../../../constants";
import Status from "../cabecalho/_Status";
import useFormatter from "../../../../hooks/useFormatter";

export default function ConsultivoConsultaRespostaDetailPage() {
  const { t } = useTranslation();
  const { formatDate } = useFormatter();
  const isEditable = useSelector(hasPermissaoSelector(Consulta.Permissoes.RESPOSTA_ALTERAR.id));
  const resposta = useSelector(respostaSelector);
  const loading = useLoading(fetchResposta.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const consultaId = match.params.consultaId;

  const handleEdit = () => {
    history.replace(`/consultivo/consultas/${consultaId}/resposta/edit`);
  };

  return (
    <Spin spinning={loading}>
      {isEditable &&
        <ActionBar>
          <ActionButton.Edit onClick={handleEdit}/>
        </ActionBar>
      }
      <Row gutter={[16, 8]}>
        <Col flex="200px"><TextItem label={t('Data Prevista para conclusão')}>{formatDate(resposta?.dataPrevista)}</TextItem></Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="600px"><TextItem label={t('Resposta')}>{resposta?.resposta}</TextItem></Col>
        <Col flex="200px"><Status/></Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px"><TextItem label={t('Tags')}>{resposta?.tags?.join(', ')}</TextItem></Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px"><TextItem label={t('Permissões')}>{resposta?.usuariosPermissao?.map(it => <div>{it.nome}</div>)}</TextItem></Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="400px"><TextItem label={t('Id do Projeto')}>{resposta?.projeto?.id}</TextItem></Col>
        <Col flex="400px"><TextItem label={t('Id da Consulta de Origem')}>{resposta?.consultaOrigem?.id}</TextItem></Col>
      </Row>
    </Spin>
  )
}
